import React, { useEffect, useState } from 'react';
import './../styles/styles.css';
import ProductCard from '../components/ProductCard';
import visuelLivrets from "../assets/visuel-livrets2-publishable.png";


export default function Store() {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  const API_URL = process.env.REACT_APP_API_URL;

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const response = await fetch(`${API_URL}/products/products.php`);
        if (!response.ok) {
          throw new Error("Erreur lors du chargement des produits");
        }
        const data = await response.json();

        console.log('Produits reçus de l’API :', data); // <-- log complet de l'API
        setProducts(data); 
      } catch (error) {
        console.error("Erreur API :", error);
        setProducts([]);
      } finally {
        setLoading(false);
      }
    };

    fetchProducts();
  }, [API_URL]);

  if (loading) {
    return (
      <section className="section-black store-header">
        <h1>NOTRE CATALOGUE</h1>
        <p>Chargement des produits...</p>
      </section>
    );
  }

  return (
    <div>
      <section className="section-black store-header">
        <h1>NOTRE CATALOGUE</h1>
        <p>Découvrez tous nos scénarios et trouvez l'enquête qui vous correspond.</p>
        <p>Age recommandé pour nos scénarios + de 16 ans. Durée approximative de jeu : 2-3 heures.</p>
      </section>

      <section className="section-cream product-list">
        <div className="card-grid">
          {products.length > 0 ? (
            products.map(product => {


              return (
                <ProductCard
                  key={product.id}
                  id={product.id}
                  title={product.name}
                  image={product.image_url}
                  price={`${parseFloat(product.price).toFixed(2)}`} 
                  description={product.description}
                  min_players={product.min_players}
                  max_players={product.max_players}
                  stripe_price_id={product.stripe_price_id}
                />
              );
            })
          ) : (
            <p style={{ textAlign: 'center', width: '100%' }}>
              Aucun produit disponible pour le moment.
            </p>
          )}
        </div>
      </section>


      <section className="section-black">
        <h1>NOS MURDER PARTY TÉLÉCHARGEABLES</h1>
        <p>Préparez-vous à une soirée inoubliable ! Nos murder party prêtes à jouer vous offrent une expérience immersive complète, directement accessible.</p>
        
        {/* Le conteneur pour l'image et la liste. On utilise une classe pour le grid. */}
        <div className="murder-party-content-grid">
          
          {/* Colonne 1 : L'image du contenu du jeu */}
          <div className="grid-item content-image">
            {/* Remplacez 'chemin/vers/votre/image.jpg' par le chemin réel de votre image */}
            <img 
              src={visuelLivrets}
              alt="Aperçu du contenu de la Murder Party"
              className="img-livrets" 
            />
          </div>
          
          {/* Colonne 2 : Le listing du contenu */}
          <div>
            <h2>Que contiennent nos murder party téléchargeables ?</h2>
            <p>
              Tout est inclus, <strong className="bordeaux-strong"> 100% prêt à l'emploi </strong> : Téléchargez, imprimez (ou envoyez en digital), et jouez ! Les kits comprennent les règles complètes, les livrets rôles, un guide détaillé pour l'organisateur (sans spoiler), et les éléments de preuves.
            </p>
            <ul style={{ 
                marginLeft: 'auto', 
                marginRight: 'auto', 
                width: 'max( 25%, 200px )',
              }}>
              <li>Règles du jeu</li>
              <li>Livret des évènements</li>
              <li>Livrets des personnages</li>
            </ul>
            <p>
              Tous ces éléments sont téléchargeables instantanément via notre site internet.
            </p>
          </div>
          
        </div>
      </section>
    </div>
  );
}
